import { computed, ref } from 'vue';
import { StoreState, useStore } from '@/store';

type FormKey = keyof StoreState['form'];

export function useForm() {
  const store = useStore();
  const valid = ref<true | string | null>(null);

  const computedHelper = (name: FormKey) =>
    computed({
      get: () => store.state.form[name],
      set: (value: string) => store.commit.setFormValue(name, value),
    });

  const name = computedHelper('name');
  const firstName = computedHelper('firstName');
  const lastName = computedHelper('lastName');
  const email = computedHelper('email');
  const phone = computedHelper('phone');

  const validate = (splitName = false) => {
    const { name, firstName, lastName, email } = store.state.form;
    if (splitName) {
      if (!firstName || !lastName) return 'Please enter your name';
    } else {
      if (!name) return 'Please enter your name';
    }
    if (
      !email ||
      !email.includes('@') ||
      !email.includes('.') ||
      email.length < 6
    )
      return 'Please enter a valid email address.';
    return true;
  };

  return { name, firstName, lastName, email, phone, valid, validate };
}
